<template>
  <div class="tra">
    <!-- горячие действия -->
    <router-link
        :to="{ name: 'tournament_edit', params: { id: tournament.id } }"
        target="_blank"
        rel="noopener"
    >
      <b-btn variant="outline-primary" class="tra__btn" v-b-tooltip.hover.top="'Редактировать'">
        <i class="fa fa-pencil"></i>
      </b-btn>
    </router-link>

    <router-link
        :to="{ name: 'tournament_standings', params: { standingId: tournament.id } }"
        target="_blank"
        rel="noopener"
    >
      <b-btn variant="outline-primary" class="tra__btn" v-b-tooltip.hover.top="'Сетка'">
        <i class="fa fa-sitemap"></i>
      </b-btn>
    </router-link>

    <router-link
        :to="{ name: 'tournament_teams', params: { id: tournament.id } }"
        target="_blank"
        rel="noopener"
    >
      <b-btn variant="outline-primary" class="tra__btn" v-b-tooltip.hover.top="'Заявки'">
        <i class="fa fa-users"></i>
        <b-badge v-if="awaitedCount > 0" variant="warning" class="tra__badge">{{ awaitedCount }}</b-badge>
      </b-btn>
    </router-link>

    <!-- редкие и опасные действия -->
    <b-btn
        :id="popoverId"
        variant="outline-secondary"
        class="tra__btn"
        v-b-tooltip.hover.top="'Ещё'"
    >
      <i class="fa fa-ellipsis-h"></i>
    </b-btn>

    <!-- container=body, иначе меню обрежется скроллом таблицы -->
    <b-popover
        :target="popoverId"
        container="body"
        triggers="click blur"
        placement="bottomleft"
        custom-class="tra-popover"
    >
      <div class="tra-menu">
        <template v-if="isSquad">
          <button type="button" class="tra-menu__item" @click="emitAndClose('rating')">
            <i :class="hasRating ? 'fa fa-star' : 'fa fa-star-o'"></i>
            {{ hasRating ? 'Рейтинг рассчитан' : 'Рассчитать рейтинг' }}
          </button>

          <button
              type="button"
              class="tra-menu__item"
              :disabled="!hasRating"
              @click="emitAndClose('recalculate')"
          >
            <i class="fa fa-refresh"></i>
            Перерасчёт рейтинга
          </button>

          <div class="tra-menu__divider"></div>
        </template>

        <button
            type="button"
            class="tra-menu__item tra-menu__item--danger"
            @click="emitAndClose('delete')"
        >
          <i class="fa fa-trash"></i>
          Удалить турнир
        </button>
      </div>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "TournamentRowActions",
  props: {
    tournament: {
      type: Object,
      required: true,
    },
  },
  computed: {
    popoverId() {
      return `tra-more-${this.tournament.id}`;
    },
    awaitedCount() {
      return Number(this.tournament.awaited_entries_count) || 0;
    },
    isSquad() {
      const format = this.tournament.format;
      return String(format && format.name).toLowerCase() === "squad";
    },
    hasRating() {
      return Number(this.tournament.team_ratings_count) > 0;
    },
  },
  methods: {
    emitAndClose(action) {
      this.$root.$emit("bv::hide::popover", this.popoverId);
      this.$emit(action, this.tournament.id);
    },
  },
};
</script>

<style scoped lang="scss">
.tra {
  display: flex;
  align-items: center;
  gap: 5px;

  &__btn {
    position: relative;
    width: 32px;
    height: 32px;
    padding: 0;
    line-height: 1;
  }

  &__badge {
    position: absolute;
    top: -6px;
    right: -6px;
    padding: 2px 4px;
    font-size: 9px;
  }
}

.tra-menu {
  min-width: 200px;

  &__item {
    display: flex;
    align-items: center;
    gap: 9px;
    width: 100%;
    padding: 7px 10px;
    border: 0;
    border-radius: 4px;
    background: none;
    font-size: 13px;
    color: #2c323f;
    text-align: left;

    i {
      width: 13px;
      font-size: 12px;
      color: #898989;
    }

    &:hover:not(:disabled) {
      background: #f4f2ff;
    }

    &:disabled {
      opacity: 0.45;
      cursor: default;
    }

    &--danger {
      color: #dc3545;

      i {
        color: #dc3545;
      }

      &:hover:not(:disabled) {
        background: #fdf0f0;
      }
    }
  }

  &__divider {
    height: 1px;
    margin: 5px 0;
    background: #f1f1f1;
  }
}
</style>

<style lang="scss">
/* попап рендерится в body — стили не могут быть scoped */
.tra-popover {
  max-width: none;

  .popover-body {
    padding: 5px;
  }
}
</style>
